import { Button, makeStyles, TextField, Typography } from "@material-ui/core";
import React from "react";
import AdjustIcon from "@material-ui/icons/Adjust";
import { Link } from "react-router-dom";

function LoginTable(props) {
  const {
    email,
    setEmail,
    password,
    setPassword,
    handleLogin,
    handleSignUp,
    hasAccount,
    setHasAccount,
    emailError,
    passwordError,
  } = props;
  const useStyles = makeStyles({
    Login: {
      width: 250,
      padding: "50px 0",
      border: "3px solid #fd3a69",
      borderRadius: 15,
    },

    input: {
      textDecoration: "none",
    },
    textFiled: {
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    button: {
      width: "80%",
      borderRadius: 10,
      textAlign: "center",
      fontSize: 18,
      padding: "7px 0 10px 0",
      color: "white",
      backgroundColor: "#fd3a69",
      margin: "0 auto",
    },
  });

  const classes = useStyles();
  return (
    <div className={classes.Login}>
      <div style={{ textAlign: "center" }}>
        <AdjustIcon style={{ color: "#fd3a69", fontSize: "70" }} />
      </div>
      <form className={classes.textFiled}>
        <TextField
          style={{ width: "100%" }}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            className: classes.input,
          }}
          autoComplete="off"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          id="standard-basic"
          label="Username"
        />
      </form>

      <p>{emailError}</p>

      <form className={classes.textFiled}>
        <TextField
          style={{ width: "100%" }}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            className: classes.input,
          }}
          autoComplete="off"
          required
          id="standard-required"
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </form>

      <p>{passwordError}</p>
      <div style={{ textAlign: "center" }}>
        {hasAccount ? (
          <>
            <div className={classes.button} onClick={handleLogin}>
              Sign in
            </div>
            <p>
              Don't have account?
              <Typography
                onClick={() => setHasAccount(!hasAccount)}
                style={{ color: "#fd3a69" }}
              >
                Sign up
              </Typography>
            </p>
          </>
        ) : (
          <>
            <div className={classes.button} onClick={handleLogin}>
              Sign up
            </div>
            <p>
              Have an account?
              <Typography
                onClick={() => setHasAccount(!hasAccount)}
                style={{ color: "#fd3a69" }}
              >
                Sign in
              </Typography>
            </p>
          </>
        )}
        <Link to="/" style={{ textDecoration: "none", color: "#fd3a69" }}>
          <Typography>Back to Home Page</Typography>
        </Link>
      </div>
    </div>
  );
}
export default LoginTable;
